import { render, staticRenderFns } from "./CopyToLayoutModal.vue?vue&type=template&id=0a08e174"
import script from "./CopyToLayoutModal.vue?vue&type=script&lang=js"
export * from "./CopyToLayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a08e174')) {
      api.createRecord('0a08e174', component.options)
    } else {
      api.reload('0a08e174', component.options)
    }
    module.hot.accept("./CopyToLayoutModal.vue?vue&type=template&id=0a08e174", function () {
      api.rerender('0a08e174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/CopyToLayoutModal.vue"
export default component.exports